export enum ProgressTypeEnum {
    PENDING = 'PENDING',
    DONE = 'DONE',
}
